<!--
   Created by qing on 2021/8/7
   Des:
-->
<template>
  <div class="msg-qrcode-container">
    <div class="qrcode-title">
      数据一码通
    </div>
    <div class="qr-code-image-container">
      <img
        id="qrcodeImg"
        :class="['NORMAL', 'VERTICAL_SIMPLE', 'VERTICAL_COMPLEX'].includes(showStyle) ? 'vertical-img' : 'horizontal-img'"
        class="qr-code-image"
        :src="imageUrl">
    </div>
    <div class="tips" v-if="onload">
      请长按图片保存到相册
    </div>
    <div class="prompt">
      由{{$store.getters.webName}}提供技术支持
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        imageUrl: '',
        showStyle: '',
        onload: false,
        toast: null
      }
    },
    created() {

      this.toast = this.$toast.loading()
      this.$store.dispatch('actionQrcodeMsgDetail', {
        qrcodeId: this.$route.query.qrcode,
        needFile: 'NO'
      }).then(res => {
        this.imageUrl = res.imageUrl
        this.showStyle = res.showStyle
      }).catch(console.error)

    },
    mounted() {
      this.$nextTick(() => {

        const img = document.getElementById('qrcodeImg')
        img.onload = () => {
          this.onload = true
          if (this.toast) this.toast.clear()
        }
      })
    },
    methods: {
    }
  }
</script>

<style lang="less">

  .msg-qrcode-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    position: relative;

    .qrcode-title {
      font-size: 26px;
      margin-top: 60px;
      margin-bottom: 100px;
    }

    .qr-code-image-container {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      margin-bottom: 10px;
    }

    .qr-code-image {
      height: 160px;
      width: auto;
    }

    .vertical-img {
      width: 200px;
      height: auto;
    }

    .horizontal-img {
      height: 160px;
      width: auto;
      max-width: 340px;
    }

    .tips {
      margin-top: 30px;
      color: #6d6d6d;
      font-size: 13px;
    }

    .prompt {
      position: absolute;
      bottom: 40px;
      font-size: 12px;
      color: #5e6d82;
      text-align: center;
    }
  }
</style>
